export default "__VITE_ASSET__8a8872ab__"